module.exports = __webpack_public_path__ + "static/img/airoad_img1.e87f6624.png";